import { defineComponent as _defineComponent } from 'vue'
import { formatNumberWithCommas } from '~/utils/format';
import FilmTokenIcon from '~/components/Token/FilmTokenIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeRewardMetric',
  props: {
    title: null,
    count: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  count?: number;
};



return { __sfc: true,props, formatNumberWithCommas, FilmTokenIcon }
}

})